export default {
  LayoutMode: {
    FLEX: 'flex',
    DEFAULT: 'default'
  },
  Events: {
    SHOW_LOGIN: 'show-login'
  },
  typeExperience: {
    INVOICE: 'invoice',
    INVOICEOCRCAR: 'invoiceocr_car',
    INVOICEOCRQUOTA: 'invoiceocr_quota',
    INVOICEOCRTRAINTICKET: 'invoiceocr_trainticket',
    INVOICEOCRTAXI: 'invoiceocr_taxi',
    INVOICEOCRFLIGHT: 'invoiceocr_flight',
    INVOICEOCRTAXPAYMENT: 'invoiceocr_taxpayment',
    INVOICEOCRBUS: 'invoiceocr_bus',
    INVOICEOCRSHIP: 'invoiceocr_ship',
    INVOICEOCRTOLL: 'invoiceocr_toll',
    INVOICEOCRROLL: 'invoiceocr_roll',
    INVOICEOCRGENERAL: 'invoiceocr_general',
    INVOICEOCRMIXED: 'invoiceocr_mixed',

    FINANCIAL_BILL: 'financial_bill',
    FINANCIALSLICE_BILL: 'financialslice_bill',
    INSURANCE_BILL: 'insurance_bill',

    BUSINESSLICENSE: 'business_license',
    ORGANIZATIONCODECERTIFICATE: 'organization_code_certificate',
    CORPORATEENTITYCERTIFICATE: 'corporate_entity_certificate',
    ENTERPRISELICENSE: 'enterprise_license'

  }
};



// WEBPACK FOOTER //
// ./src/components/open/common/Constant.js